<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Credit Level Name"
                  v-model="creditLevel.name"
                  type="text"
                  :rules="rules.creditLevelNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="periodDays"
                  label="Credit Level periodDays"
                  v-model="creditLevel.periodDays"
                  type="text"
                  :rules="rules.periodDaysRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-textarea
                  name="description"
                  label="Credit Level Description"
                  v-model="creditLevel.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-textarea>
              </v-flex>
              <v-flex sm12 v-if="creditLevel.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="creditLevel.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="creditLevel.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="creditLevel.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="creditLevel.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="creditLevel.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { creditLevelService } from "../../services/credit-level-service";
import { CreditLevel } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { CreditLevelFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";

export default {
  name: "CreditLevelDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Credit Level",
        disabled: false,
        to: "credit-levels"
      },
      {
        text: "Credit Level Detail",
        disabled: true
      }
    ],
    createdDate: "",
    updatedDate: "",
    creditLevel: new CreditLevel(),
    oldCreditLevel: new CreditLevel(),
    saveLoading: false,
    responseError: "",
    rules: new CreditLevelFormRules()
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new Credit Level
    } else {
      this.getCreditLevelDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        creditLevelService
          .saveCreditLevel(this.creditLevel)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getCreditLevelDetail(id) {
      creditLevelService
        .getCreditLevelDetail(id)
        .then(res => {
          this.creditLevel = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.creditLevel.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.creditLevel.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );

          this.oldCreditLevel = Object.assign({}, res.data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.creditLevel.id) {
        this.creditLevel = new CreditLevel();
      } else {
        this.creditLevel = Object.assign({}, this.oldCreditLevel);
      }
    },
    goBack() {
      this.$router.push("/credit-levels");
    }
  }
};
</script>

